export default "__VITE_ASSET__jL2peY1P__"